import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const SedeCell = ({ cellInfo, checked }) => {
  return (
    <Field name='sedes'>
      {({ field }) => <Form.Checkbox {...field} id={`check-${cellInfo._id}`} label={cellInfo.nombre} value={cellInfo._id} checked={checked} />}
    </Field>
  )
}

export default React.memo(SedeCell)
